/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderAuthOptions } from './FxIdApplicationPublicDataBuilderAuthOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderAuthOptions,
    FxIdApplicationPublicDataBuilderAuthOptionsFromJSON,
    FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderAuthOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderAuthOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPublicDataBaseAuth
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPublicDataBaseAuth = FxIdApplicationPublicDataBuilderAuthOptions;

export function FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseAuth {
    return FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseAuth {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderAuthOptions(json)) {
        return FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseAuth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderAuthOptions(value)) {
        return FxIdApplicationPublicDataBuilderAuthOptionsToJSON(value as FxIdApplicationPublicDataBuilderAuthOptions);
    }

    return {};
}

